import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Point from "slotworks/utils/geom/point";

export default class GatewayResult extends BonusResult {

    /** For debugging purposes */
    public resultType: string = "GatewayResult";

    public gatewayType: GatewayType;

    public freespinsWon: number;

    public wildsAwarded: number;

    public winAmount: number;

    public matches: number;

    public symbols: string[] = [];

    public positions: Point[];

    public symbolType: string;
}

export enum GatewayType {
    FREESPINS,
    MC_BONUS
}
